import { render, staticRenderFns } from "./wSwap.vue?vue&type=template&id=3e447ea4&scoped=true&"
import script from "./wSwap.vue?vue&type=script&lang=js&"
export * from "./wSwap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e447ea4",
  null
  
)

export default component.exports